import logo from "../../images/aboutpage.png"


export default function AboutTitle() {
  return (
    <img className="a-tt" src={logo} alt="contact logo" />
   
  );
}